export const GET_EXAMPAPER = "GET_EXAMPAPER"
export const GET_EXAMPAPER_SUCCESS = "GET_EXAMPAPER_SUCCESS"
export const ADD_NEW_EXAMPAPERS = "ADD_NEW_EXAMPAPERS"
export const ADD_NEW_EXAMPAPERS_SUCCESS = "ADD_NEW_EXAMPAPERS_SUCCESS"
export const RESET_EXAMPAPERS_BOARDCATEGORY = "RESET_EXAMPAPERS_BOARDCATEGORY"
export const DELETE_EXAMPAPERS = " DELETE_EXAMPAPERS"
export const DELETE_EXAMPAPERS_SUCCESS = "DELETE_EXAMPAPERS_SUCCESS"
